import { useState, useEffect } from 'react';
import { FaEnvelope, FaArrowRight, FaLock, FaEye, FaEyeSlash } from 'react-icons/fa';
import {FiEye,FiEyeOff} from 'react-icons/fi';
import '../Styles/ForgotPassword.css'
import logo from '../Images/SAVI AI full.png'
import axios from 'axios';

const ForgotPassword = () => {
  const [email, setEmail] = useState('');
  const [otp, setOtp] = useState('');
  const [newPassword, setNewPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [stage, setStage] = useState('email'); // 'email', 'otp', 'reset', 'success'
  const [errorMessage, setErrorMessage] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const [showPassword, setShowPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);

  useEffect(() => {
      const savedTheme = localStorage.getItem('theme') || 'light';
      document.documentElement.setAttribute('data-theme', savedTheme);
    }, []);
    useEffect(() => {
      // Set theme on mount
      const setTheme = () => {
        const savedTheme = localStorage.getItem('theme') || 'light';
        document.documentElement.setAttribute('data-theme', savedTheme);
      };
      setTheme();
  
      // Listen for theme changes in other tabs/components
      const handleStorage = (e) => {
        if (e.key === 'theme') {
          setTheme();
        }
      };
      window.addEventListener('storage', handleStorage);
  
      return () => window.removeEventListener('storage', handleStorage);
    }, []);

  const handleEmailSubmit = async (e) => {
    e.preventDefault();
    setIsLoading(true);
    setErrorMessage('');

    if (!email) {
      setErrorMessage('Please enter your email address');
      setIsLoading(false);
      return;
    }

    try {
      const response = await axios.post(process.env.REACT_APP_SAVIAI_SEND_EMAIL_OTP_API, {
        email: email
      });
      setStage('otp');
    } catch (error) {
      setErrorMessage(error.response?.data?.message || 'Failed to send OTP. Please try again.');
    } finally {
      setIsLoading(false);
    }
  };

  const handleOtpSubmit = async (e) => {
    e.preventDefault();
    setIsLoading(true);
    setErrorMessage('');

    if (!otp || otp.length < 6) {
      setErrorMessage('Please enter a valid OTP code');
      setIsLoading(false);
      return;
    }

    try {
      const response = await axios.post(process.env.REACT_APP_SAVIAI_VERIFY_EMAIL_OTP_API, {
        email: email,
        otp: otp
      });
      setStage('reset');
    } catch (error) {
      setErrorMessage(error.response?.data?.message || 'Invalid OTP. Please try again.');
    } finally {
      setIsLoading(false);
    }
  };

  const handlePasswordReset = async (e) => {
    e.preventDefault();
    setIsLoading(true);
    setErrorMessage('');

    if (!newPassword || newPassword.length < 6) {
      setErrorMessage('Password must be at least 6 characters');
      setIsLoading(false);
      return;
    }

    if (newPassword !== confirmPassword) {
      setErrorMessage('Passwords do not match');
      setIsLoading(false);
      return;
    }

    try {
      const response = await axios.post(process.env.REACT_APP_SAVIAI_FORGOT_PASSWORD_API, {
        email: email,
        otp: otp,
        new_password: newPassword,
        confirm_password: confirmPassword
      });
      setStage('success');
    } catch (error) {
      setErrorMessage(error.response?.data?.message || 'Failed to reset password. Please try again.');
    } finally {
      setIsLoading(false);
    }
  };

  const handleResendOtp = async () => {
    setIsLoading(true);
    setErrorMessage('');

    try {
      const response = await axios.post(process.env.REACT_APP_SAVIAI_SEND_EMAIL_OTP_API, {
        email: email
      });
      setErrorMessage('');
      // You could add a success message here if needed
    } catch (error) {
      setErrorMessage(error.response?.data?.message || 'Failed to resend OTP. Please try again.');
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="forgot-main-container">
      <header className="forgot-header">
        <div className="forgot-logo">
          <img src={logo} alt="Company Logo" className="forgot-logo-image" />
        </div>
        <button className="forgot-signup-button">Sign Up</button>
      </header>
    <div className="forgot-content-container">
      <div className="forgot-form-container">
        {stage === 'email' && (
          <>
            <h1 className="forgot-form-title">
              Enter your <span className="forgot-title-highlight">Email</span>
            </h1>

            <form onSubmit={handleEmailSubmit}>
              <div className="forgot-input-group">
                <span className="forgot-input-icon">
                  <FaEnvelope />
                </span>
                <input
                  type="email"
                  className="forgot-input-field"
                  placeholder="Enter your email address"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                />
                <button
                  type="button"
                  className={`forgot-next-button ${isLoading ? 'loading' : ''}`}
                  onClick={() => document.querySelector('form').requestSubmit()}
                  disabled={isLoading}
                >
                  {isLoading ? (
                    <div className="spinner"></div>
                  ) : (
                    <FaArrowRight />
                  )}
                </button>
              </div>

              {errorMessage && (
                <div className="forgot-error-message">{errorMessage}</div>
              )}

              {/* <button type="submit" className="forgot-button">
                Send OTP
              </button> */}
            </form>

            <div className="forgot-signup-prompt">
              Remember your password? <a href="/login" className="forgot-signup-link">Log in</a>
            </div>
          </>
        )}

        {stage === 'otp' && (
          <>
            <h1 className="forgot-form-title">
              Enter <span className="forgot-title-highlight">verification code</span>
            </h1>

            <p style={{ marginBottom: '20px', color: '#555', fontSize: '15px' }}>
              We've sent a verification code to <strong>{email}</strong>
            </p>

            <form onSubmit={handleOtpSubmit}>
              <div className="forgot-input-group">
                <input
                  type="text"
                  className="forgot-input-field"
                  placeholder="Enter OTP"
                  value={otp}
                  onChange={(e) => setOtp(e.target.value)}
                  style={{ paddingLeft: '15px' }}
                  maxLength={6}
                />
              </div>

              {errorMessage && (
                <div className="forgot-error-message">{errorMessage}</div>
              )}

              <button type="submit" className="forgot-button">
                Verify OTP
              </button>
            </form>

            <div className="forgot-signup-prompt">
              Didn't receive the code? <a href="#" className="forgot-signup-link" onClick={(e) => {
                e.preventDefault();
                handleResendOtp();
              }}>Resend OTP</a>
            </div>

            <div className="forgot-signup-prompt" style={{ marginTop: '10px' }}>
              <a href="#" className="forgot-signup-link" onClick={(e) => {
                e.preventDefault();
                setStage('email');
              }}>Use a different email</a>
            </div>
          </>
        )}

        {stage === 'reset' && (
          <>
            <h1 className="forgot-form-title">
              Create new <span className="forgot-title-highlight">password</span>
            </h1>

            <form onSubmit={handlePasswordReset}>
              <div className="forgot-input-group">
                <span className="forgot-input-icon">
                  <FaLock />
                </span>
                <input
                  type={showPassword ? "text" : "password"}
                  className="forgot-input-field"
                  placeholder="Enter new password"
                  value={newPassword}
                  onChange={(e) => setNewPassword(e.target.value)}
                />
                <button
                  type="button"
                  className="forgot-password-toggle"
                  onClick={() => setShowPassword(!showPassword)}
                >
                  {showPassword ? <FaEyeSlash /> : <FaEye />}
                </button>
              </div>

              <div className="forgot-input-group" style={{ marginTop: '10px' }}>
                <span className="forgot-input-icon">
                  <FaLock />
                </span>
                <input
                  type={showConfirmPassword ? "text" : "password"}
                  className="forgot-input-field"
                  placeholder="Confirm new password"
                  value={confirmPassword}
                  onChange={(e) => setConfirmPassword(e.target.value)}
                />
                <button
                  type="button"
                  className="forgot-password-toggle"
                  onClick={() => setShowConfirmPassword(!showConfirmPassword)}
                >
                  {showConfirmPassword ? <FaEyeSlash /> : <FaEye />}
                </button>
              </div>

              {errorMessage && (
                <div className="forgot-error-message">{errorMessage}</div>
              )}

              <button type="submit" className="forgot-button" disabled={isLoading}>
                {isLoading ? 'Resetting...' : 'Reset Password'}
              </button>
            </form>
          </>
        )}

        {stage === 'success' && (
          <>
            <h1 className="forgot-form-title">
              Password <span className="forgot-title-highlight">updated!</span>
            </h1>

            <p style={{ marginBottom: '30px', color: '#555', fontSize: '15px' }}>
              Your password has been successfully reset. You can now log in with your new password.
            </p>

            <a href="/login">
              <button className="forgot-button">
                Go to Login
              </button>
            </a>
          </>
        )}
      </div>
    </div>
    </div>
  );
};

export default ForgotPassword;
